import { useAuth0 as e } from "@auth0/auth0-react";
import { AppError as t, AuthorizationError as n, CollaboratorInvitation as r, CollaboratorTeamMember as i, DomainTakkenLicense as a, DomainUsage as o, DomainVegaLicenses as s, ERROR_CODE as c, MemberApplicant as l, NetworkError as u, OperationHistoryFacets as d, OperationHistoryPage as f, OperationHistorySettings as p, ParsableDate as m, Plan as h, PlanSummary as g, ProviderUser as _, ProviderUserBlockSources as v, ProviderUserLockout as y, ReadAdminCustomerProfile as b, ReadCustomer as x, ReadCustomerContracts as S, ReadCustomerProfile as C, ReadDomain as w, ReadDomainMfaState as ee, ReadDomainUserAuthenticationMethods as te, ReadInvitation as ne, ReadOrganization as T, ReadPolicy as re, ReadProviderUserAuthenticationMethods as ie, ReadRole as ae, ReadSubscription as oe, ReadUser as se, ensureError as E } from "esa-core";
import { createContext as D, useCallback as O, useContext as k, useEffect as ce, useMemo as A, useRef as j, useState as M } from "react";
import { jsx as N } from "@emotion/react/jsx-runtime";
import le, { default as ue } from "swr";
import de from "swr/infinite";
import { z as P } from "zod";
export * from "swr";
//#region lib/services/ApiClient.ts
var F = class extends t {
	response;
	apiErrorCode;
	status;
	constructor(e, t) {
		let { status: n } = e, { url: r } = e, i = c.APPLICATION_ERROR;
		n >= 500 ? i = c.SERVER_ERROR : n === 404 ? i = c.NOT_FOUND_ERROR : n >= 400 && (i = c.CLIENT_ERROR), super("HttpError", {
			url: r,
			status: n,
			response: e
		}, void 0, i), this.response = e, this.apiErrorCode = t, this.name = new.target.name, this.status = n;
	}
}, I = "https://a.com", L = class {
	baseUrl;
	getAccessToken;
	customHeaders;
	constructor(e, t, n) {
		this.baseUrl = e, this.getAccessToken = t, this.customHeaders = n;
	}
	async composeHeaders(e) {
		e?.method === void 0 && (e.method = "GET"), e.headers = {
			...e?.headers,
			...this.customHeaders
		}, this.getAccessToken && (e.headers = {
			Authorization: `Bearer ${await this.getAccessToken()}`,
			...e?.headers
		});
	}
	async request(e, n = {}) {
		let r = new URL(e, I).href.replace(I, this.baseUrl);
		await this.composeHeaders(n);
		let i = await fetch(r, n).catch((e) => {
			throw new u({ url: r }, E(e));
		});
		if (!i.ok) throw new F(i, (await i.json().catch((e) => {
			throw new t("Failed to parse Error response", { ur: i.url }, E(e));
		})).errorCode);
		return i;
	}
	async requestJsonResponse(e, n) {
		let r = await this.request(e, n);
		try {
			return await r.json();
		} catch (e) {
			throw new t("Failed to parse GET response", { ur: r.url }, E(e));
		}
	}
	get({ path: e }) {
		return this.requestJsonResponse(e, { method: "GET" });
	}
	getCsv({ path: e }) {
		return this.request(e, { method: "GET" }).then((e) => e.blob()).then((e) => ({ url: window.URL.createObjectURL(e) }));
	}
	put({ path: e, body: t }) {
		return this.requestJsonResponse(e, {
			method: "PUT",
			headers: { "Content-Type": "application/json" },
			body: t
		});
	}
	post({ path: e, body: t }) {
		return this.requestJsonResponse(e, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: t
		});
	}
	delete({ path: e }) {
		return this.requestJsonResponse(e, { method: "DELETE" });
	}
}, R = ({ baseUrl: t, audience: r, scope: i, customHeaders: a }) => {
	let { error: o, getAccessTokenSilently: s, getAccessTokenWithPopup: c, isLoading: l } = e(), u = A(() => new L(t ?? r, async () => {
		let e = await s({ authorizationParams: {
			audience: r,
			scope: i
		} }).catch(async (e) => {
			if (e?.error === "consent_required") return c({ authorizationParams: {
				audience: r,
				scope: i
			} }).catch((e) => {
				throw new n({ reason: "Failed to get access token" }, E(e));
			});
			throw new n({ reason: "Failed to get access token" }, E(e));
		});
		if (e == null) throw new n({ reason: "Failed to get access token(token is empty)" });
		return e;
	}, a), [
		r,
		t,
		s,
		c,
		i,
		a
	]);
	return l ? {
		isLoading: !0,
		error: null,
		apiClient: null
	} : o ? {
		isLoading: !1,
		error: o,
		apiClient: null
	} : {
		isLoading: !1,
		error: null,
		apiClient: u
	};
}, fe = (e) => {
	let t = j(e), n = j(void 0), r = j(!1), i = j(!1), [, a] = M(0);
	return r.current && (i.current = !0), ce(() => (r.current ||= (n.current = t.current(), !0), a(1), () => {
		i.current && n.current && n.current();
	}), []), { refresh: () => {
		n.current && n.current(), n.current = t.current();
	} };
}, pe = ({ initial: e } = { initial: !1 }) => {
	let [t, n] = M(e);
	return [
		t,
		O(() => {
			n(!0);
		}, [n]),
		O(() => {
			n(!1);
		}, [n])
	];
}, me = () => {
	let [e, t] = M(null), n = O((e) => {
		t(e);
	}, [t]), r = O(() => {
		t(null);
	}, [t]);
	return e === null ? {
		open: !1,
		entity: null,
		openDialog: n,
		onClose: r
	} : {
		open: !0,
		entity: e,
		openDialog: n,
		onClose: r
	};
}, he = ({ filter: e, ...t }) => {
	let [{ page: n, perPage: r, params: i }, a] = M({
		page: 0,
		perPage: 10,
		...t
	}), o = O((e) => a((t) => ({
		...t,
		page: e
	})), [a]), s = O((e) => a((t) => ({
		...t,
		perPage: e,
		page: 0
	})), [a]), c = O((e) => a((t) => ({
		...t,
		params: e,
		page: 0
	})), [a]), l = A(() => n * r, [n, r]);
	return {
		setPage: o,
		setPerPage: s,
		setParams: c,
		applyFilter: O((t) => {
			let a = e(t, i);
			return a.length <= l ? {
				items: a.slice(0, r),
				count: a.length,
				page: 0,
				perPage: r
			} : {
				items: a.slice(l, l + r),
				count: a.length,
				page: n,
				perPage: r
			};
		}, [
			e,
			i,
			l,
			n,
			r
		])
	};
}, ge = ({ filter: e, ...t }) => {
	let [{ params: n }, r] = M({ ...t });
	return {
		params: n,
		setParams: O((e) => r((t) => ({
			...t,
			params: e,
			page: 0
		})), [r]),
		applyFilter: O((t) => e(t, n), [e, n])
	};
}, _e = (e) => Array.isArray(e), z = (e, t) => {
	if (e == null || e === "") return !1;
	if (_e(e)) for (let n = 0; n < e.length; n += 1) {
		let r = e[n];
		if (z(r, t)) return !0;
	}
	else if (typeof e == "object") {
		let n = Object.values(e);
		for (let e = 0; e < n.length; e += 1) {
			let r = n[e];
			if (z(r, t)) return !0;
		}
	}
	return t(e);
}, ve = (e, t) => !t || t.value == null ? e : e.filter((e) => z(e, (e) => typeof e == "string" && e.includes(t.value))), ye = () => {
	let [e, t] = M({
		open: !1,
		anchorEl: null
	}), n = O((e) => t({
		open: !0,
		anchorEl: e.currentTarget
	}), [t]), r = O(() => t({
		open: !1,
		anchorEl: null
	}), [t]), i = O((e) => {
		t(e === null ? {
			open: !1,
			anchorEl: null
		} : {
			open: !0,
			anchorEl: e
		});
	}, [t]);
	return {
		...e,
		openMenu: i,
		closeMenu: r,
		handleClick: n
	};
}, be = (e, t) => e.isLoading ? {
	isLoading: !0,
	error: null,
	domainVegaLicenses: null
} : e.error ? {
	isLoading: !1,
	error: e.error,
	domainVegaLicenses: null
} : e.domain.ebone?.customerId == null ? {
	isLoading: !1,
	error: null,
	domainVegaLicenses: null
} : t.isLoading ? {
	isLoading: !0,
	error: null,
	domainVegaLicenses: null
} : t.error ? {
	isLoading: !1,
	error: t.error,
	domainVegaLicenses: null
} : {
	isLoading: !1,
	error: null,
	domainVegaLicenses: t.model
}, B = D(null), xe = ({ children: e, baseUrl: t, audience: n, customHeaders: r }) => {
	let i = A(() => ({
		baseUrl: t,
		audience: n,
		customHeaders: r
	}), [
		t,
		n,
		r
	]);
	return /* @__PURE__ */ N(B.Provider, {
		value: i,
		children: e
	});
}, V = () => {
	let e = k(B);
	if (!e) throw new t("useEsaApiContext must be called inside `<EsaApiProvider>`", {});
	return e;
}, H = D(null), Se = ({ children: e, baseUrl: t, audience: n, customHeaders: r }) => {
	let i = A(() => ({
		baseUrl: t,
		audience: n,
		customHeaders: r
	}), [
		t,
		n,
		r
	]);
	return /* @__PURE__ */ N(H.Provider, {
		value: i,
		children: e
	});
}, U = () => {
	let e = k(H);
	if (!e) throw new t("useOneApiContext must be called inside `<OneApiContext>`", {});
	return e;
}, W = ({ api: { audience: e, baseUrl: n, path: r, customHeaders: i }, schema: a, config: o }) => {
	let { isLoading: s, apiClient: c, error: l } = R({
		audience: e,
		baseUrl: n,
		customHeaders: i
	}), { data: u, error: d, mutate: f, isValidating: p } = ue(s || l ? null : r, (e) => {
		if (l) throw l;
		if (!c) throw new t("Unreachable code", { path: e });
		return c.get({ path: e });
	}, o);
	if (d != null) return {
		isLoading: !1,
		error: E(d),
		model: null,
		mutate: f,
		isValidating: p
	};
	if (u == null) return {
		isLoading: !0,
		error: null,
		model: null,
		mutate: f,
		isValidating: p
	};
	let m = a.safeParse(u);
	return m.success ? {
		isLoading: !1,
		error: null,
		model: m.data,
		mutate: f,
		isValidating: p
	} : {
		isLoading: !1,
		error: m.error,
		model: null,
		mutate: f,
		isValidating: p
	};
}, G = ({ api: { path: e }, schema: t, config: n }) => {
	let { audience: r, baseUrl: i, customHeaders: a } = V(), o = W({
		api: {
			audience: r,
			baseUrl: i,
			path: e,
			customHeaders: a
		},
		schema: t,
		config: n
	});
	return A(() => o, [o]);
}, K = ({ domainUid: e }) => {
	let { isLoading: t, error: n, model: r, mutate: i } = G({
		api: { path: `/domains/${e}` },
		schema: w
	});
	return t ? {
		isLoading: t,
		error: null,
		domain: null,
		mutate: i
	} : n ? {
		isLoading: !1,
		error: n,
		domain: null,
		mutate: i
	} : {
		isLoading: !1,
		error: null,
		domain: r,
		mutate: i
	};
}, Ce = ({ domainUid: e }) => {
	let t = K({ domainUid: e });
	return be(t, G({
		api: { path: t.domain?.ebone?.customerId == null ? null : `/domains/${e}/licenses` },
		schema: s
	}));
}, we = (e) => {
	let t = e.filter((e) => e.licenseName === "fcCustomizeBasic" && (e.licenseAttributeMap.fcName ?? "") !== "");
	if (t.length === 0) return null;
	let n = t.sort((e, t) => e.licenseAttributeMap.fcName.localeCompare(t.licenseAttributeMap.fcName, "ja"))[0], r = n.licenseAttributeMap.pcLogo ?? "", i = n.licenseAttributeMap.smpLogo ?? "";
	return {
		fcName: n.licenseAttributeMap.fcName,
		pcLogo: r === "" ? i : r,
		smpLogo: i === "" ? r : i
	};
}, Te = ({ domainUid: e }) => {
	let t = Ce({ domainUid: e }), n = A(() => t.domainVegaLicenses && we(t.domainVegaLicenses.licenses), [t.domainVegaLicenses]);
	return t.isLoading ? {
		isLoading: !0,
		error: null,
		fcLicense: null
	} : t.error ? {
		isLoading: !1,
		error: t.error,
		fcLicense: null
	} : t.domainVegaLicenses === null ? {
		isLoading: !1,
		error: null,
		fcLicense: null
	} : {
		isLoading: !1,
		error: null,
		fcLicense: n
	};
}, q = (e, t) => e[0].items.length === 0 || e[e.length - 1].items.length < t, Ee = (e) => {
	let t = [];
	return e.forEach((e) => {
		t = [...t, ...e.items];
	}), t;
}, De = 50, J = ({ api: { audience: e, baseUrl: n, path: r, customHeaders: i, query: a }, schema: o, startIndex: s = 1, itemsPerPage: c = De, initialSize: l = 1, lazyLoad: u = !0, allFetch: d = !0, shouldFetch: f = !0 }) => {
	let { isLoading: p, apiClient: m, error: h } = R({
		audience: e,
		baseUrl: n,
		customHeaders: i
	}), { data: g, error: _, mutate: v, isValidating: y, size: b, setSize: x } = de((e, t) => !f || p || t != null && (t.items == null || t.items.length === 0) ? null : `${r}?startIndex=${s + e * c}&itemsPerPage=${c}${a ?? ""}`, (e) => {
		if (h) throw h;
		if (!m) throw new t("Unreachable code", { path: e });
		return m.get({ path: e });
	}, { initialSize: l }), S = P.array(P.object({ items: o.array() }));
	if (ce(() => {
		if (d) {
			let e = S.safeParse(g);
			e.success && _ == null && (q(e.data, c) || x(e.data.length + 1));
		}
	}, [
		_,
		S,
		x,
		g,
		c,
		o,
		d
	]), !f) return {
		isLoading: !1,
		error: null,
		models: [],
		mutate: v,
		isValidating: y,
		size: b,
		setSize: x
	};
	if (_ != null) return {
		isLoading: !1,
		error: E(_),
		models: null,
		mutate: v,
		isValidating: y,
		size: b,
		setSize: x
	};
	if (!g) return {
		isLoading: !0,
		error: null,
		models: null,
		mutate: v,
		isValidating: y,
		size: b,
		setSize: x
	};
	let C = S.safeParse(g);
	return C.success ? !u && !q(C.data, c) ? {
		isLoading: !0,
		error: null,
		models: null,
		mutate: v,
		isValidating: y,
		size: b,
		setSize: x
	} : {
		isLoading: !1,
		error: null,
		models: Ee(C.data),
		mutate: v,
		isValidating: y,
		size: b,
		setSize: x
	} : {
		isLoading: !1,
		error: C.error,
		models: null,
		mutate: v,
		isValidating: y,
		size: b,
		setSize: x
	};
}, Y = ({ api: { path: e, query: t }, schema: n, startIndex: r, itemsPerPage: i, initialSize: a, lazyLoad: o, allFetch: s, shouldFetch: c }) => {
	let { audience: l, baseUrl: u, customHeaders: d } = V(), f = J({
		api: {
			audience: l,
			baseUrl: u,
			path: e,
			query: t,
			customHeaders: d
		},
		schema: n,
		startIndex: r,
		itemsPerPage: i,
		initialSize: a,
		lazyLoad: o,
		allFetch: s,
		shouldFetch: c
	});
	return A(() => f, [f]);
}, Oe = (e) => {
	let { domainUid: t } = e, n = Y({
		api: { path: `/domains/${t}/invitations` },
		schema: ne,
		...e
	});
	return n.isLoading ? {
		...n,
		invitations: n.models
	} : n.error ? e.isAdmin ? {
		...n,
		invitations: n.models
	} : {
		...n,
		isLoading: !1,
		error: null,
		invitations: []
	} : {
		...n,
		invitations: n.models
	};
}, X = P.object({
	domainUid: P.string(),
	content: P.string(),
	registrantEmail: P.string(),
	modifiedAt: m
}), ke = P.object({ memo: X.nullish() }).transform(({ memo: e }) => e == null ? { status: "none" } : {
	status: "registered",
	...e
}), Ae = ({ domainUid: e, canRead: t }) => {
	let { isLoading: n, error: r, model: i, mutate: a } = G({
		api: { path: t ? `/domains/${e}/memo` : null },
		schema: ke
	});
	return t ? n ? {
		status: "loading",
		mutate: a
	} : r ? {
		status: "error",
		error: r,
		mutate: a
	} : {
		status: "loaded",
		memo: i,
		mutate: a
	} : {
		status: "unauthorized",
		mutate: a
	};
}, je = (e) => {
	let { domainUid: t } = e, n = Y({
		api: { path: `/domains/${t}/member_applicants` },
		schema: l,
		...e
	});
	return n.isLoading ? {
		...n,
		memberApplicants: n.models
	} : n.error ? e.isAdmin ? {
		...n,
		memberApplicants: n.models
	} : {
		...n,
		isLoading: !1,
		error: null,
		memberApplicants: []
	} : {
		...n,
		memberApplicants: n.models
	};
}, Me = (e) => {
	let { domainUid: t } = e, n = Y({
		api: { path: `/domains/${t}/organizations` },
		schema: T,
		...e
	});
	if (n.isLoading || n.error) return {
		...n,
		organizations: n.models,
		organizationUids: null
	};
	let r = new Map(n.models.map((e) => [e.organizationUid, e])), i = n.models.map(({ name: e, organizationUid: t }) => ({
		name: e,
		organizationUid: t
	})), a = n.models.map(({ organizationUid: e }) => e), o = (e) => e == null ? "" : r.get(e)?.name ?? "";
	return {
		...n,
		organizations: n.models,
		organizationUids: a,
		organizationMap: r,
		organizationOptions: i,
		getOrganizationName: o
	};
}, Z = ({ planType: e }) => `&type=${e}`, Ne = (e) => {
	let { domainUid: t } = e, n = Y({
		api: {
			path: `/domains/${t}/plans`,
			query: Z(e)
		},
		schema: h,
		...e
	});
	return n.isLoading || n.error, {
		...n,
		plans: n.models
	};
}, Pe = (e) => {
	let { domainUid: t } = e, n = Y({
		api: {
			path: `/domains/${t}/plan_summaries`,
			query: Z(e)
		},
		schema: g,
		...e
	});
	return n.isLoading || n.error, {
		...n,
		plans: n.models
	};
}, Fe = (e) => {
	let { domainUid: t } = e, n = Y({
		api: { path: `/domains/${t}/roles` },
		schema: ae,
		...e
	});
	if (n.isLoading || n.error) return {
		...n,
		roles: n.models
	};
	let r = new Map(n.models.map((e) => [e.roleUid, e])), i = n.models.map(({ name: e, roleUid: t }) => ({
		name: e,
		roleUid: t
	})), a = n.models.map(({ roleUid: e }) => e), o = (e) => e == null ? "" : r.get(e)?.name ?? "";
	return {
		...n,
		roles: n.models,
		roleUids: a,
		roleOptions: i,
		getRoleName: o
	};
}, Ie = P.object({
	supportAccountProhibitionUid: P.string(),
	domainUid: P.string(),
	registrantEmail: P.string(),
	reason: P.string(),
	modifiedAt: m
}), Le = P.object({ supportAccountProhibition: Ie.nullish() }).transform(({ supportAccountProhibition: e }) => e == null ? { status: "none" } : {
	status: "registered",
	...e
}), Re = ({ domainUid: e, canRead: t = !0 }) => {
	let { isLoading: n, error: r, model: i, mutate: a } = G({
		api: { path: t ? `/domains/${e}/support_account_prohibition` : null },
		schema: Le
	});
	return t ? n ? {
		status: "loading",
		mutate: a
	} : r ? {
		status: "error",
		error: r,
		mutate: a
	} : {
		status: "loaded",
		prohibition: i,
		mutate: a
	} : {
		status: "unauthorized",
		mutate: a
	};
}, ze = P.object({
	supportAccountReasonUid: P.string(),
	domainUid: P.string(),
	registrantEmail: P.string(),
	approver: P.string(),
	approvedOn: m,
	approvalReason: P.string()
}), Be = (e, t) => e ? {
	type: "only",
	uids: t
} : { type: "all" }, Ve = ze.extend({
	closedAt: m.nullish(),
	restrictsOrganizations: P.boolean(),
	allowedOrganizationUids: P.array(P.string()),
	restrictsRoles: P.boolean(),
	allowedRoleUids: P.array(P.string())
}).transform(({ closedAt: e, restrictsOrganizations: t, allowedOrganizationUids: n, restrictsRoles: r, allowedRoleUids: i, ...a }) => {
	let o = {
		...a,
		organizationRestriction: Be(t, n),
		roleRestriction: Be(r, i)
	};
	return e == null ? {
		...o,
		status: "open"
	} : {
		...o,
		status: "closed",
		closedAt: e
	};
}), He = P.object({ items: P.array(Ve) }), Ue = ({ domainUid: e, canRead: t = !0 }) => {
	let { isLoading: n, error: r, model: i, mutate: a } = G({
		api: { path: t ? `/domains/${e}/support_account_reasons` : null },
		schema: He
	});
	return t ? n ? {
		status: "loading",
		mutate: a
	} : r ? {
		status: "error",
		error: r,
		mutate: a
	} : {
		status: "loaded",
		reasons: i.items,
		mutate: a
	} : {
		status: "unauthorized",
		mutate: a
	};
}, Q = P.object({
	approver: P.string(),
	approvedOn: m,
	reason: P.string()
}), We = P.discriminatedUnion("type", [P.object({
	type: P.literal("temporary"),
	providerUser: _,
	expiresAt: m,
	issuedByEmail: P.string(),
	supportAccountReasonUid: P.string(),
	customerApproval: Q
}), P.object({
	type: P.literal("legacy"),
	providerUser: _
})]), Ge = P.object({ items: P.array(We) }), Ke = ({ domainUid: e, canRead: t = !0 }) => {
	let { isLoading: n, error: r, model: i, mutate: a } = G({
		api: { path: t ? `/domains/${e}/support_accounts` : null },
		schema: Ge
	});
	return t ? n ? {
		status: "loading",
		mutate: a
	} : r ? {
		status: "error",
		error: r,
		mutate: a
	} : {
		status: "loaded",
		supportAccounts: i.items,
		mutate: a
	} : {
		status: "unauthorized",
		mutate: a
	};
}, qe = ({ domainUid: e }) => {
	let { isLoading: t, error: n, model: r, mutate: i } = G({
		api: { path: `/domains/${e}/takken_license` },
		schema: a
	});
	return t ? {
		isLoading: t,
		error: null,
		domainTakkenLicense: null,
		mutate: i
	} : n ? {
		isLoading: !1,
		error: n,
		domainTakkenLicense: null,
		mutate: i
	} : {
		isLoading: !1,
		error: null,
		domainTakkenLicense: r,
		mutate: i
	};
}, Je = (e) => {
	let { domainUid: t } = e, n = Y({
		api: { path: `/domains/${t}/users/authentication_methods` },
		schema: te,
		...e
	});
	return n.isLoading || n.error, {
		...n,
		authenticationMethods: n.models
	};
}, Ye = (e) => {
	let { domainUid: t } = e, n = Y({
		api: { path: `/domains/${t}/users` },
		schema: se,
		...e
	});
	return n.isLoading || n.error, {
		...n,
		users: n.models
	};
}, Xe = (e) => {
	let { collaboratorTeamUid: t } = e, n = Y({
		api: { path: `/collaborator_teams/${t}/members` },
		schema: i,
		...e
	});
	return n.isLoading || n.error, {
		...n,
		members: n.models
	};
}, Ze = (e) => {
	let { collaboratorTeamUid: t } = e, n = Y({
		api: { path: `/collaborator_teams/${t}/invitations` },
		schema: r,
		...e
	});
	return n.isLoading || n.error, {
		...n,
		invitations: n.models
	};
}, Qe = ({ api: { path: e }, schema: t, config: n }) => {
	let { audience: r, baseUrl: i, customHeaders: a } = U(), o = W({
		api: {
			audience: r,
			baseUrl: i,
			path: e,
			customHeaders: a
		},
		schema: t,
		config: n
	});
	return A(() => o, [o]);
}, $ = 1024, $e = (e) => {
	let { isLoading: t, error: n, model: r } = Qe({
		api: { path: e == null ? null : `/directory/1.0/domain/${e}/usage` },
		schema: o
	});
	return { usageInfoList: A(() => t || n != null ? [] : [{
		typeName: "賃貸物件登録情報",
		usage: r.rent_bukken_usage,
		usageMax: r.rent_bukken_limit,
		unit: "件"
	}, {
		typeName: "ファイル登録状況",
		usage: r.file_usage == null ? null : Math.floor(r.file_usage / $ / $),
		usageMax: r.file_limit == null ? null : Math.floor(r.file_limit / $ / $),
		unit: "MB"
	}], [
		r,
		n,
		t
	]) };
}, et = ({ planUid: e, config: t }) => {
	let { isLoading: n, error: r, model: i, mutate: a } = G({
		api: { path: `/plans/${e}` },
		schema: h,
		config: t
	});
	return n ? {
		isLoading: n,
		error: null,
		plan: null,
		mutate: a
	} : r ? {
		isLoading: !1,
		error: r,
		plan: null,
		mutate: a
	} : {
		isLoading: !1,
		error: null,
		plan: i,
		mutate: a
	};
}, tt = (e) => {
	let t = Y({
		api: { path: "/policies" },
		schema: re,
		...e
	});
	return t.isLoading || t.error, {
		...t,
		policies: t.models
	};
}, nt = ({ providerUserUid: e, enabled: t, config: n }) => {
	let { isLoading: r, error: i, model: a, mutate: o } = G({
		api: { path: t ? `/provider_users/${encodeURIComponent(e)}/authentication_methods` : null },
		schema: ie,
		config: n
	});
	return r ? {
		isLoading: r,
		error: null,
		authenticationMethods: null,
		mutate: o
	} : i ? {
		isLoading: !1,
		error: i,
		authenticationMethods: null,
		mutate: o
	} : {
		isLoading: !1,
		error: null,
		authenticationMethods: a,
		mutate: o
	};
}, rt = (e) => {
	let { providerUserUid: t } = e, n = Y({
		api: { path: `/provider_users/${t}/member_applicants` },
		schema: l,
		...e
	});
	return n.isLoading || n.error, {
		...n,
		memberApplicants: n.models
	};
}, it = P.object({ items: P.array(y) }), at = ({ providerUserUid: e }) => {
	let { isLoading: t, error: n, model: r } = G({
		api: { path: `/provider_users/${e}/lockouts` },
		schema: it
	});
	return t ? {
		isLoading: t,
		error: null,
		lockouts: null
	} : n ? {
		isLoading: !1,
		error: n,
		lockouts: null
	} : {
		isLoading: !1,
		error: null,
		lockouts: r.items
	};
}, ot = P.object({ sources: v }), st = ({ providerUserUid: e, canRead: t = !0 }) => {
	let { isLoading: n, error: r, model: i, mutate: a } = G({
		api: { path: t ? `/provider_users/${e}/blocks` : null },
		schema: ot
	});
	return t ? n ? {
		status: "loading",
		mutate: a
	} : r ? {
		status: "error",
		error: r,
		mutate: a
	} : {
		status: "loaded",
		sources: i.sources,
		mutate: a
	} : {
		status: "unauthorized",
		mutate: a
	};
}, ct = (e) => e.emails == null ? "" : `&emails=${e.emails.map(encodeURIComponent).join(",")}`, lt = (e) => {
	let t = Y({
		api: {
			path: "/provider_users",
			query: ct(e)
		},
		schema: _,
		...e
	});
	return t.isLoading || t.error, {
		...t,
		providerUsers: t.models
	};
}, ut = P.object({
	domain: P.object({
		domainUid: P.string(),
		name: P.string()
	}),
	providerUser: _,
	expiresAt: m,
	issuedByEmail: P.string(),
	supportAccountReasonUid: P.string(),
	customerApproval: Q
}), dt = P.object({
	startIndex: P.number(),
	itemsPerPage: P.number(),
	totalCounts: P.number(),
	items: P.array(ut)
}), ft = P.enum(["self", "all"]), pt = ({ scope: e, search: t, startIndex: n, itemsPerPage: r }) => `/support_accounts?scope=${e}&startIndex=${n}&itemsPerPage=${r}${t === "" ? "" : `&search=${encodeURIComponent(t)}`}`, mt = ({ canRead: e = !0, ...t }) => {
	let { isLoading: n, error: r, model: i, mutate: a } = G({
		api: { path: e ? pt(t) : null },
		schema: dt
	});
	return e ? n ? {
		status: "loading",
		mutate: a
	} : r ? {
		status: "error",
		error: r,
		mutate: a
	} : {
		status: "loaded",
		supportAccounts: i.items,
		totalCounts: i.totalCounts,
		mutate: a
	} : {
		status: "unauthorized",
		mutate: a
	};
}, ht = ({ userUid: e }) => {
	let { isLoading: t, error: n, model: r, mutate: i } = G({
		api: { path: `/users/${e}` },
		schema: se
	});
	return t ? {
		isLoading: t,
		error: null,
		user: null,
		mutate: i
	} : n ? {
		isLoading: !1,
		error: n,
		user: null,
		mutate: i
	} : {
		isLoading: !1,
		error: null,
		user: r,
		mutate: i
	};
}, gt = ({ domainUid: e, config: t }) => {
	let { isLoading: n, error: r, model: i, mutate: a } = G({
		api: { path: `/domains/${e}/mfa_state` },
		schema: ee,
		config: t
	});
	return n ? {
		isLoading: n,
		error: null,
		domainMfaState: null,
		mutate: a,
		enableMfa: !1,
		enforcedMfa: !1,
		enableTotp: !1,
		enablePasskey: !1
	} : r ? {
		isLoading: !1,
		error: r,
		domainMfaState: null,
		mutate: a,
		enableMfa: !1,
		enforcedMfa: !1,
		enableTotp: !1,
		enablePasskey: !1
	} : {
		isLoading: !1,
		error: null,
		domainMfaState: i,
		mutate: a,
		enableMfa: i.enableMfa,
		enforcedMfa: i.enforcedMfa,
		enableTotp: i.enableTotp,
		enablePasskey: i.enablePasskey
	};
}, _t = (e, t) => new URLSearchParams({
	from: e.toISOString(),
	to: t.toISOString()
}), vt = ({ filter: e, order: t, startIndex: n, itemsPerPage: r }) => {
	let i = _t(e.from, e.to), a = {
		providerUserUids: e.providerUserUids,
		organizationUids: e.organizationUids,
		operations: e.operations,
		ips: e.ips,
		ipPrefixes: e.ipPrefixes
	};
	return Object.entries(a).forEach(([e, t]) => {
		t.length > 0 && i.set(e, t.join(","));
	}), i.set("order", t), i.set("startIndex", String(n)), i.set("itemsPerPage", String(r)), i;
}, yt = ({ domainUid: e, query: t, config: n }) => G({
	api: { path: t === null ? null : `/domains/${e}/operation_histories?${vt(t).toString()}` },
	schema: f,
	config: n
}), bt = ({ domainUid: e, query: t, config: n }) => G({
	api: { path: t === null ? null : `/domains/${e}/operation_history_facets?${_t(t.from, t.to).toString()}` },
	schema: d,
	config: n
}), xt = ({ domainUid: e, query: t, config: n }) => G({
	api: { path: t === null ? null : `/domains/${e}/operation_history_settings` },
	schema: p,
	config: n
}), St = P.object({ items: P.array(oe) }), Ct = ({ customerId: e }) => {
	let { isLoading: t, error: n, model: r } = G({
		api: { path: `/customers/${e}/subscriptions?includeChildren=true` },
		schema: St
	});
	return t ? {
		isLoading: t,
		error: null,
		subscriptions: null
	} : n ? {
		isLoading: !1,
		error: n,
		subscriptions: null
	} : {
		isLoading: !1,
		error: null,
		subscriptions: r.items
	};
}, wt = ({ customerId: e }) => {
	let { isLoading: t, error: n, model: r } = G({
		api: { path: `/customers/${e}` },
		schema: x
	});
	return t ? {
		isLoading: t,
		error: null,
		customer: null
	} : n ? {
		isLoading: !1,
		error: n,
		customer: null
	} : {
		isLoading: !1,
		error: null,
		customer: r
	};
}, Tt = ({ customerId: e }) => {
	let { isLoading: t, error: n, model: r } = G({
		api: { path: `/admin/customers/${e}/profile` },
		schema: b
	});
	return t ? {
		isLoading: t,
		error: null,
		profile: null
	} : n ? {
		isLoading: !1,
		error: n,
		profile: null
	} : {
		isLoading: !1,
		error: null,
		profile: r
	};
}, Et = ({ customerId: e }) => {
	let { isLoading: t, error: n, model: r } = G({
		api: { path: e == null ? null : `/customers/${e}/contracts` },
		schema: S,
		config: {
			revalidateOnFocus: !1,
			revalidateOnReconnect: !1
		}
	});
	return e == null || t ? {
		isLoading: !0,
		error: null,
		contracts: null
	} : n ? {
		isLoading: !1,
		error: n,
		contracts: null
	} : {
		isLoading: !1,
		error: null,
		contracts: r
	};
}, Dt = ({ customerId: e }) => {
	let { isLoading: t, error: n, model: r } = G({
		api: { path: `/customers/${e}/profile` },
		schema: C
	});
	return t ? {
		isLoading: t,
		error: null,
		profile: null
	} : n ? {
		isLoading: !1,
		error: n,
		profile: null
	} : {
		isLoading: !1,
		error: null,
		profile: r
	};
}, Ot = ({ providerUserUid: e }) => {
	let { isLoading: t, error: n, model: r, mutate: i } = G({
		api: { path: `/provider_users/${e}` },
		schema: _
	});
	return t ? {
		isLoading: t,
		error: null,
		providerUser: null,
		mutate: i
	} : n ? {
		isLoading: !1,
		error: n,
		providerUser: null,
		mutate: i
	} : {
		isLoading: !1,
		error: null,
		providerUser: r,
		mutate: i
	};
}, kt = (e) => {
	let t = [];
	return e.domainUids != null && t.push("domainUids=" + e.domainUids.join(",")), t.length === 0 ? "" : `&${t.join("&")}`;
}, At = (e) => {
	let t = Y({
		api: {
			path: "/domains",
			query: kt(e)
		},
		schema: w,
		...e
	});
	return t.isLoading || t.error, {
		...t,
		domains: t.models
	};
}, jt = (e) => {
	let t = [];
	return e.domainUids != null && t.push("domainUids=" + e.domainUids.join(",")), e.organizationUids != null && t.push("organizationUids=" + e.organizationUids.join(",")), t.length === 0 ? "" : `&${t.join("&")}`;
}, Mt = (e) => {
	let t = Y({
		api: {
			path: "/organizations",
			query: jt(e)
		},
		schema: T,
		...e
	});
	return t.isLoading || t.error, {
		...t,
		organizations: t.models
	};
}, Nt = (e) => {
	let t = [];
	return e.domainUids != null && t.push("domainUids=" + e.domainUids.join(",")), t.length === 0 ? "" : `&${t.join("&")}`;
}, Pt = (e) => {
	let t = Y({
		api: {
			path: "/roles",
			query: Nt(e)
		},
		schema: ae,
		...e
	});
	return t.isLoading || t.error, {
		...t,
		roles: t.models
	};
}, Ft = ({ initialOrderBy: e }) => {
	let [t, n] = M("desc"), [r, i] = M(e);
	return {
		order: t,
		orderBy: r,
		onRequestSort: O((e) => {
			n(r === e && t === "desc" ? "asc" : "desc"), i(e);
		}, [
			r,
			t,
			n,
			i
		])
	};
};
//#endregion
export { L as ApiClient, Q as CustomerApproval, X as DomainMemo, xe as EsaApiProvider, F as HttpError, Se as OneApiProvider, We as SupportAccount, ut as SupportAccountListItem, Ie as SupportAccountProhibition, Ve as SupportAccountReason, ft as SupportAccountScope, ve as textFilter, Z as toDomainPlansQuery, vt as toOperationHistoryPageParams, ct as toProviderUsersQuery, pt as toSupportAccountsPath, Tt as useAdminCustomerProfile, R as useApiClient, Ze as useCollaboratorTeamInvitations, Xe as useCollaboratorTeamMembers, wt as useCustomer, Et as useCustomerContracts, Dt as useCustomerProfile, Ct as useCustomerSubscriptions, pe as useDialog, K as useDomain, Oe as useDomainInvitations, je as useDomainMemberApplicants, Ae as useDomainMemo, gt as useDomainMfaState, yt as useDomainOperationHistories, bt as useDomainOperationHistoryFacets, xt as useDomainOperationHistorySettings, Me as useDomainOrganizations, Pe as useDomainPlanSummaries, Ne as useDomainPlans, Fe as useDomainRoles, Re as useDomainSupportAccountProhibition, Ue as useDomainSupportAccountReasons, Ke as useDomainSupportAccounts, qe as useDomainTakkenLicense, Je as useDomainUserAuthenticationMethods, Ye as useDomainUsers, At as useDomains, fe as useEffectOnce, me as useEntityDialog, V as useEsaApiContext, Te as useFcLicense, he as useFilter, ge as useGlobalFilter, ye as useMenu, W as useModel, J as useModels, U as useOneApiContext, $e as useOneApiUsage, Mt as useOrganizations, et as usePlan, tt as usePolicies, Ot as useProviderUser, nt as useProviderUserAuthenticationMethods, st as useProviderUserBlock, at as useProviderUserLockouts, rt as useProviderUserMemberApplicants, lt as useProviderUsers, Pt as useRoles, le as useSWR, Ft as useSort, mt as useSupportAccounts, ht as useUser };

//# sourceMappingURL=esa-hooks.mjs.map